import { render, staticRenderFns } from "./SegmentedFeed.vue?vue&type=template&id=fdfd57b2"
import script from "./SegmentedFeed.vue?vue&type=script&lang=js"
export * from "./SegmentedFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports